const STOCKS_UPDATE = (state, {
  stocks
}) => {
  stocks.map(stock => {
    stock.selected = false
    stock.noGraph = false
    if (state.watchList.stockSymbols.includes(`${stock.publicationid}:${stock.alias}`)) stock.selected = true
    return stock
  })
  state.stocks = stocks
  state.isLoading = false
}

const WATCH_LIST_UPDATE = (state, {
  watchList,
  stock
}) => {
  if (stock) {
    stock.selected = !stock.selected
    stock.selected ? addToWatchList(state, stock) : removeFromWatchList(state, stock)
  } else {
    const selectedStocks = state.stocks.filter(stock => {
      if (watchList.stocks.includes(`${stock.publicationid}:${stock.alias}`)) {
        stock.selected = true
        state.watchList.stockSymbols.unshift(`${stock.publicationid}:${stock.alias}`)
        return stock
      }
      stock.selected = false
    })
    state.watchList.stocks = selectedStocks.reverse()
    state.watchList.id = watchList._id
  }
}

const removeFromWatchList = (state, stock) => {
  const stockPos = state.watchList.stockSymbols.indexOf(`${stock.publicationid}:${stock.alias}`)

  state.watchList.stocks.splice(stockPos, 1)
  state.watchList.stockSymbols.splice(stockPos, 1)
  state.stocks.forEach(stockItem => {
    if (`${stock.publicationid}:${stock.alias}` === `${stockItem.publicationid}:${stockItem.alias}`) stockItem.selected = false
  })
}

const addToWatchList = (state, stock) => {
  state.watchList.stocks.unshift(stock)
  state.watchList.stockSymbols.unshift(`${stock.publicationid}:${stock.alias}`)
}

const STOCKS_UPDATE_FAILURE = (state) => {
  state.stocks = []
  state.isLoading = false
}

const STOCK_NO_GRAPH = (state, stockAlias) => {
  stockAlias.forEach(alias => {
    state.watchList.stocks.forEach(stock => {
      alias = alias.substring(alias.indexOf(':') + 1)
      if (stock.alias === alias) stock.noGraph = true
    })
  })
}

export default {
  STOCKS_UPDATE,
  WATCH_LIST_UPDATE,
  STOCKS_UPDATE_FAILURE,
  STOCK_NO_GRAPH
}
